<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="max-width: 600px;">
  <div class="search-wrapper mat-elevation-z1" style="flex: 1;">
    <div class="search" fxLayout="row" fxLayoutAlign="start center">
      <div *ngIf="isSearching"><mat-spinner style="float:right;" diameter="25"></mat-spinner></div>
      <mat-icon [ngClass]="{'animate': true}">search</mat-icon>
      <input
        style="flex: 1; min-width: 0;"
        type="text"
        [value]="kwSearch || ''"
        (input)="onKeywordChange($any($event.target).value)"
        [placeholder]="'LABEL.SEARCH' | translate"
      />
      <button *ngIf="kwSearch" style="background-color:transparent; flex-shrink: 0;" matTooltip="Clear" type="button" class="btn" (click)="clearSearch()">
        <mat-icon class="material-icons" style="color:#293683;">clear</mat-icon>
      </button>
    </div>
  </div>
  <button mat-raised-button type="button"
    style="flex-shrink: 0; background-color: #3f51b5; color: white; font-size: 11px; padding: 0 8px; min-width: 0; line-height: 36px; height: 36px;"
    (click)="openAdvancedSearchDialog()"
    matTooltip="Ricerca Avanzata"
    [matBadge]="activeFiltersCount > 0 ? activeFiltersCount : null"
    matBadgeColor="warn"
    matBadgeSize="small">
    <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle; margin-right: 4px;">manage_search</mat-icon>
    Ricerca A.
  </button>
  <button *ngIf="activeFiltersCount > 0" mat-icon-button color="warn" type="button" style="flex-shrink: 0;"
    (click)="resetDialogFilters()"
    [matTooltip]="'LABEL.RESET_FILTERS_BTN' | translate">
    <mat-icon>filter_alt_off</mat-icon>
  </button>
</div>
